.supplier-list {
  color: var(--color-muted);
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: disc inside;
  margin: 0;
  padding: 0;
}

.supplier-item {
  font-weight: 400;
}

.supplier-selected {
  font-weight: 700;
}

/* Indented to line up with the contact rows under the list marker. */
.crm-status {
  align-items: center;
  color: var(--color-text-success, #1a7f37);
  display: flex;
  font-size: 12px;
  gap: 4px;
  padding: 2px 0 0 16px;
}

/* Indented to line up with the contact rows under the list marker, and a block
   so it does not run inline against the supplier name. */
.crm-unlinked {
  margin: 2px 0 0;
  padding-left: 16px;
}

.crm-link {
  align-items: center;
  color: var(--color-text-info, #339cff);
  display: inline-flex;
  font-size: 13px;
  gap: 4px;
  margin: 4px 0 0 16px;
  text-decoration: none;
  width: fit-content;
}

.crm-link:hover,
.crm-link:focus-visible {
  text-decoration: underline;
}

.contact {
  align-items: center;
  background: transparent;
  border: none;
  color: var(--color-muted);
  cursor: pointer;
  display: flex;
  font-size: 13px;
  gap: 4px;
  padding: 2px 0 0 16px;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
}

.contact-dash {
  color: var(--color-border-strong);
}
